import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Componente que faz scroll para o topo da página quando a rota muda
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
};
